import { NgComponentOutlet } from '@angular/common';
import { NgModule } from '@angular/core';

import { PersonalTokenDataModule } from '@recruitee/personal-token-data';

import { FeatureGuardFacade } from './feature-guard.facade';
import { FeaturesGuardModel } from './feature-guard.model';

@NgModule({
  imports: [PersonalTokenDataModule, NgComponentOutlet],
  providers: [FeatureGuardFacade, FeaturesGuardModel],
  exports: [],
})
export class FeatureGuardModule {}

export { FeatureGuardFacade };

export { FeatureGuardGuard } from './feature-guard.guard';
export * from './feature-guard.model';
export * from './feature-guard.types';
